import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  Select,
  SimpleGrid,
  Text
} from "@chakra-ui/react";
import { ModeloNegocioType } from "models/modelo_negocio_type";
import { OrderType } from "models/order_type";
import { useCallback, useEffect, useState } from "react";
import formatNumber from "../hooks/formatNumber";

interface IOrderCalc {
  totalOrder: number;
  selectedModeloNegocio: ModeloNegocioType | undefined;
  brandStars: string;
  textColor: string;
  changeInput: (tipo: string, value: string) => void;
  totalCalculado: number;
  desconto: number;
  acrescimo: number;
  comissao: number;
  tipoAcrescimo: string;
  tipoComissao: string;
  tipoDesconto: string;
  accountSelected: OrderType | undefined;
}

const OrderCalc = ({
  totalOrder,
  selectedModeloNegocio,
  brandStars,
  textColor,
  changeInput,
  totalCalculado,
  desconto,
  acrescimo,
  comissao,
  tipoAcrescimo,
  tipoComissao,
  tipoDesconto,
  accountSelected
}: IOrderCalc) => {
  const [custoFixo, setCustoFixo] = useState(0);
  const [custoVenda, setCustoVenda] = useState(0);
  const [custoProduto, setCustoProduto] = useState(0);
  const [lucro, setLucro] = useState(0);
  const [custoProdutoLucro, setCustoProdutoLucro] = useState(0);
  const [precoLiquido, setPrecoLiquido] = useState(0);
  const [imposto, setImposto] = useState(0);
  const [descontoValor, setDescontoValor] = useState(desconto);
  const [acrescimoValor, setAcrescimoValor] = useState(acrescimo);
  const [comissaoValor, setComissaoValor] = useState(comissao);
  const [textoAcrescimo, setTextoAcrescimo] =useState("0");
  const [categAcrescimo, setCategAcrescimo] = useState(tipoAcrescimo);
  const [textoComissao, setTextoComissao] =  useState("0");
  const [categComissao, setCategComissao] = useState(tipoComissao);
  const [textoDesconto, setTextoDesconto] = useState("0");
  const [categDesconto, setCategDesconto] = useState(tipoDesconto);

  const calcula = useCallback(() => {
    if (selectedModeloNegocio) {
      const custofixo = Number(
        (selectedModeloNegocio.custoFixo * totalOrder) / 100
      );
      const custovenda = Number(
        (selectedModeloNegocio.custoVenda * totalOrder) / 100
      );
      const totalcustoproduto = custofixo + custovenda + totalOrder;
      const lucrovalor =
        (selectedModeloNegocio.metaLucro * totalcustoproduto) / 100;
      const custoprodutolucro = totalcustoproduto + lucrovalor;
      const custoprodutoliquido =
        custoprodutolucro + comissaoValor + acrescimoValor - descontoValor;
      const valorImposto =
        (custoprodutoliquido / (100 - selectedModeloNegocio.imposto)) * 100 -
        custoprodutoliquido;
      setCustoFixo(custofixo);
      setCustoVenda(custovenda);
      setCustoProduto(totalcustoproduto);
      setLucro(lucrovalor);
      setCustoProdutoLucro(custoprodutolucro);
      setPrecoLiquido(custoprodutoliquido);
      setImposto(valorImposto);
    }
  }, [
    acrescimoValor,
    comissaoValor,
    descontoValor,
    selectedModeloNegocio,
    totalOrder,
  ]);

  const changeDesconto = (value: string) => {
    if (categDesconto === "1") {
      const porcentagemDesconto = Number(selectedModeloNegocio?.desconto);
      const valor = Number(value);
      if (valor > porcentagemDesconto) {
        setTextoDesconto(porcentagemDesconto.toFixed(2));
        setDescontoValor(Number((porcentagemDesconto / 100) * totalOrder));
        changeInput(
          "desconto",
          Number((porcentagemDesconto / 100) * totalOrder).toString()
        );
        calcula();
      } else {
        setTextoDesconto(Number(value).toFixed(2));
        setDescontoValor(Number(Number(value) / 100) * totalOrder);
        changeInput(
          "desconto",
          (Number(Number(value) / 100) * totalOrder).toString()
        );
        calcula();
      }
    } else {
      if (
        Number(value) <
        Number((totalOrder * selectedModeloNegocio?.desconto) / 100)
      ) {
        setTextoDesconto(Number(value).toFixed(2));
        setDescontoValor(Number(value));
        changeInput("desconto", value);
        calcula();
      } else {
        setDescontoValor(
          Number((totalOrder * selectedModeloNegocio?.desconto) / 100)
        );
        changeInput(
          "desconto",
          Number(
            (totalOrder * selectedModeloNegocio?.desconto) / 100
          ).toString()
        );
        calcula();
      }
    }
  };

  const changeAcrescimo = (value: string) => {
    if(categAcrescimo === "1") {
      const valor = Number(value) / 100;
      const total = valor * totalOrder;
      changeInput("acrescimo", total.toString());
      setAcrescimoValor(total);

    } else {
      changeInput("acrescimo", value);
      setAcrescimoValor(Number(value));
    }
    calcula();
  };
  const changeComissao = (value: string) => {

    if(categComissao === "1") {
      const valor = Number(value) / 100;
      const total = valor * totalOrder;
      changeInput("comissao", total.toString());
      setComissaoValor(total);
    }
    else  {
      changeInput("comissao", value);
      setComissaoValor(Number(value));
    }

    calcula();
  };

  const changeTipoDesconto = (value: string) => {
    changeInput("tipoDesconto", value);
    setCategDesconto(value);
    setTextoDesconto("0.00");
    setDescontoValor(0);
  };

  const changeTipoAcrescimo = (value: string) => {
    changeInput("tipoAcrescimo", value);
    setCategAcrescimo(value);
    setTextoAcrescimo("0.00");
    setAcrescimoValor(0);
  };

  const changeTipoComissao = (value: string) => { 
    changeInput("tipoComissao", value);
    setCategComissao(value);
    setTextoComissao("0.00");
    setComissaoValor(0);
  }

  const changeDescontoTexto = (value: string) => {
    const porcentagemDesconto = Number(selectedModeloNegocio?.desconto);
    const valor = Number(value);
    if (categDesconto === "1") {
      if (valor > porcentagemDesconto) {
        setTextoDesconto(porcentagemDesconto.toFixed(2));
      } else {
        setTextoDesconto(value);
      }
    } else{
      setTextoDesconto(value);
    }
  };
  const changeAcrescimoTexto = (value: string) => {
    const valor = Number(value);
      if(categAcrescimo === "1") {
          if(valor > 100) {
            setTextoAcrescimo("100.00");
          } else{
            setTextoAcrescimo(value);
          }
      } else {
        setTextoAcrescimo(value);
      }
   }

   const changeComissaoTexto = (value: string) => {
    const valor = Number(value);
      if(categAcrescimo === "1") {
          if(valor > 100) {
            setTextoComissao("100.00");
          } else{
            setTextoComissao(value);
          }
      } else {
        setTextoComissao(value);
      }
   }

   useEffect(() => {
    if(accountSelected) {
      const calculoDesconto =  accountSelected.tipoDesconto === "1" ? Number((accountSelected.desconto / totalOrder) * 100).toFixed(2) : Number(accountSelected.desconto).toFixed(2);
      const calculoAcrescimo =  accountSelected.tipoAcrescimo === "1" ? Number((accountSelected.acrescimo / totalOrder)* 100).toFixed(2) : Number(accountSelected.acrescimo).toFixed(2);
      const calculoComissao = accountSelected.tipoComissao === "1" ? Number((accountSelected.comissao / totalOrder) * 100).toFixed(2) : Number(accountSelected.comissao).toFixed(2);
      setTextoDesconto(calculoDesconto);
      setTextoAcrescimo(calculoAcrescimo);
      setTextoComissao(calculoComissao);
    }
   }, [accountSelected, totalOrder])
  useEffect(() => {
    const calcula = () => {
      if (selectedModeloNegocio) {
        const custofixo = (selectedModeloNegocio.custoFixo * totalOrder) / 100;
        const custovenda =
          (selectedModeloNegocio.custoVenda * totalOrder) / 100;
        const totalcustoproduto = Number(custofixo + custovenda + totalOrder);
        const lucrovalor =
          (selectedModeloNegocio.metaLucro * totalcustoproduto) / 100;
        const custoprodutolucro = totalcustoproduto + lucrovalor;
        const custoprodutoliquido =
          custoprodutolucro + comissaoValor + acrescimoValor - descontoValor;
        const valorImposto =
          (custoprodutoliquido / (100 - selectedModeloNegocio.imposto)) * 100 -
          custoprodutoliquido;
          let calculaTotal = 0;
         calculaTotal = custoprodutoliquido + valorImposto;
        setCustoFixo(custofixo);
        setCustoVenda(custovenda);
        setCustoProduto(totalcustoproduto);
        setLucro(lucrovalor);
        setCustoProdutoLucro(custoprodutolucro);
        setPrecoLiquido(custoprodutoliquido);
        setImposto(valorImposto);
        changeInput("totalCalculado", calculaTotal.toString());
      }
    };

    if (selectedModeloNegocio) {
      calcula();
    }





  }, [
    acrescimoValor,
    calcula,
    changeInput,
    comissaoValor,
    descontoValor,
    selectedModeloNegocio,
    totalCalculado,
    totalOrder,
    textoDesconto,
  ]);
  return (
    <AccordionItem>
      <h2>
        <AccordionButton>
          <Box flex="1" textAlign="left" color={"#422AFB"} fontWeight={"bold"}>
            Calculo do Orçamento
          </Box>
          <AccordionIcon color={"#422AFB"} />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        <SimpleGrid columns={4} spacing={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Total Custos de Produção:<Text color={brandStars}>*</Text>
            </FormLabel>
            <NumberInput
              precision={2}
              value={formatNumber(Number(totalOrder))}
              isDisabled
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Custos Fixos ({selectedModeloNegocio?.custoFixo}) %
            </FormLabel>
            <NumberInput
              precision={2}
              step={10000}
              min={0}
              value={formatNumber(custoFixo)}
              isDisabled
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Custos de Venda ({selectedModeloNegocio?.custoVenda}) %
            </FormLabel>
            <NumberInput
              precision={0}
              step={10000}
              min={0}
              value={formatNumber(custoVenda)}
              isDisabled
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Total Custo do Produto
            </FormLabel>
            <NumberInput
              precision={2}
              step={10000}
              min={0}
              value={formatNumber(custoProduto)}
              isDisabled
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Lucro ({selectedModeloNegocio?.metaLucro}) %
            </FormLabel>
            <NumberInput
              precision={0}
              step={10000}
              min={0}
              value={formatNumber(lucro)}
              isDisabled
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Tipo de Desconto
            </FormLabel>
            <Select
              size="md"
              onChange={(e) => {
                changeTipoDesconto(e.target.value);
              }}
              value={categDesconto}
            >
              <option value="1">PORCENTAGEM</option>
              <option value="2">VALOR</option>
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Valor Desconto
            </FormLabel>
            <NumberInput
              precision={2}
              min={0}
              max={
                tipoDesconto === "1"
                  ? Number((totalOrder * selectedModeloNegocio?.desconto) / 100)
                  : 100000
              }
              value={textoDesconto}
              onChange={(e) => {
                changeDescontoTexto(e);
              }}
              onBlur={(e) => {
                changeDesconto(e.target.value);
              }}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Total Desconto ({selectedModeloNegocio?.desconto}) %
            </FormLabel>
            <NumberInput
              precision={2}
              isDisabled
              min={0}
              max={Number((totalOrder * selectedModeloNegocio?.desconto) / 100)}
              value={formatNumber(descontoValor)}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Tipo de Acrescimo
            </FormLabel>
            <Select size="md" onChange={(e) => {changeTipoAcrescimo(e.target.value)}} value={categAcrescimo}>
              <option value="1">PORCENTAGEM</option>
              <option value="2">VALOR</option>
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Valor Acrescimo
            </FormLabel>
            <NumberInput
              precision={2}
              min={0}
              max={ 100000
              }
              value={textoAcrescimo}
              onChange={(e) => {
                changeAcrescimoTexto(e);
              }}
              onBlur={(e) => {
                changeAcrescimo(e.target.value);
              }}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Acrescimo
            </FormLabel>
            <NumberInput
              precision={2}
              step={10000}
              min={0}
              isDisabled
              value={formatNumber(acrescimoValor)}
              onBlur={(e) => {
                changeAcrescimo(e.target.value);
              }}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Total do Preço Liquido sem Comissão
            </FormLabel>
            <NumberInput
              precision={0}
              step={10000}
              min={0}
              isDisabled
              value={formatNumber(custoProdutoLucro)}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Tipo de Comissão Adicional
            </FormLabel>
            <Select size="md" onChange={(e) => {changeTipoComissao(e.target.value)}} value={categComissao}>
              <option value="1">PORCENTAGEM</option>
              <option value="2">VALOR</option>
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Valor Comissão
            </FormLabel>
            <NumberInput
              precision={2}
              min={0}
              max={ 100000
              }
              value={textoComissao}
              onChange={(e) => {
                changeComissaoTexto(e);
              }}
              onBlur={(e) => {
                changeComissao(e.target.value);
              }}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Comissão Adicional
            </FormLabel>
            <NumberInput
              precision={2}
              step={10000}
              isDisabled
              min={0}
              value={formatNumber(comissaoValor)}
              onBlur={(e) => {
                changeComissao(e.target.value);
              }}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Total do Preço Liquido
            </FormLabel>
            <NumberInput
              precision={2}
              step={10000}
              min={0}
              isDisabled
              value={formatNumber(precoLiquido)}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Impostos ({selectedModeloNegocio?.imposto}) %
            </FormLabel>
            <NumberInput
              precision={0}
              step={10000}
              min={0}
              isDisabled
              value={formatNumber(imposto)}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Total Orçamento
            </FormLabel>
            <NumberInput
              precision={0}
              step={10000}
              min={0}
              isDisabled
              value={formatNumber(totalCalculado)}
              onChange={(e: string) => {}}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>
        </SimpleGrid>
      </AccordionPanel>
    </AccordionItem>
  );
};
export default OrderCalc;
